import { Typography, Space, Select, Button, Form, Row, Col, Tooltip } from "antd";
import {
  LeftOutlined,
  RightOutlined,
  CalendarOutlined,
  FilterOutlined
} from "@ant-design/icons";
import { useSharedState } from "../../../Shared/Services/WindowSizeService";
import useWindowSize from "../../../Shared/Utils/windowResizeUtils";
import MenuItem from "antd/es/menu/MenuItem";
import "./CustomToolBar.scss";
import { ServiceUtils } from "../../../Shared/Utils/ServiceUtils";
import { alertService } from "../../../Shared/Utils/ToasterUtils";
import { Navigate, useNavigate } from "react-router-dom";

const { Title } = Typography;

const CustomToolBar = (props) => {
  const windowSize$ = useSharedState();
  const { width } = useWindowSize();
  const [form] = Form.useForm();
  const isMobile = width <= 768;
  const navigate = useNavigate();


  const handleView = (event) => {
    props.updateView(event);
  }

  const clearFieldValues = () => {
     form.resetFields();
  }

  const goToBack = () => {
        props.onNavigate('PREV');
        props.handleNavigate('PREV',props?.date);
      };
    const goToNext = () => {
        props.onNavigate('NEXT');
        props.handleNavigate('NEXT',props?.date);
      };
    
      const goToToday = () => {
        props.onNavigate("TODAY");
        props.handleNavigate('TODAY',props?.date);
        props.onView("month");
      };

      const openFilter = () => {
        props.openFilterDrawer();
      }

      /**
   * @param {object} params - POST request payload
   * @param {string} fileName - Name of the file to download
   */
  const downloadCSV = (fileName = "medicaid.csv") => {
    ServiceUtils.getBlobRequest("exportMedicaidExcel").then(
      (response) => {
        if (response.status === 200) {
          // Create blob object
          const blob = new Blob([response.data], {
            type: "text/csv;charset=utf-8;",
          });
          const link = document.createElement("a");
          const url = URL.createObjectURL(blob);
          link.href = url;
          link.setAttribute("download", "medicaid.xlsx");
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          URL.revokeObjectURL(url);
        } else if (response.status === 401) {
          navigate("/logout");
        } else {
          alertService.error(response.data.message);
        }
      },
      (error) => {
        alertService.error("Error while fetching data");
        console.log(error);
      }
    );
  };

  return (
    <div classNmae="medicaid-toolbar">
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
          margin: "5px",
        }}
      >
        {/* LEFT SIDE */}
        <div style={{ display: "flex", alignItems: "center" }}>
          <Title
            level={5}
            style={{ margin: "0 10px 0 0", cursor: "pointer" }}
            onClick={goToToday}
          >
            <CalendarOutlined style={{ marginRight: 8 }} />
            Today
          </Title>

          <Space>
            <LeftOutlined
              style={{ fontSize: 16, cursor: "pointer" }}
              onClick={goToBack}
            />
            <RightOutlined
              style={{ fontSize: 16, cursor: "pointer" }}
              onClick={goToNext}
            />
          </Space>

          <span className="rbc-toolbar-label" style={{ marginLeft: 12 }}>
            {props.label}
          </span>

          <div style={{ paddingLeft: "12px" }}>
            <Select
              value={props.view}
              onChange={handleView}
              placeholder="Select View"
              style={{ width: isMobile ? 80 : 120 }}
            >
              <MenuItem value="month">Month</MenuItem>
              <MenuItem value="agenda">Agenda</MenuItem>
            </Select>
          </div>
        </div>

        {/* RIGHT SIDE */}
        <div style={{ display: "flex" }}>
          <div style={{ paddingRight: "7px" }}>
            <Tooltip title={"Click to apply the filters"}>
              <Button
                onClick={() => {
                  openFilter();
                }}
                style={{ fontWeight: "500" }}
                className="btn-border"
              >
                <Space>
                  <FilterOutlined />
                  {!isMobile && "Filter"}
                </Space>
              </Button>
            </Tooltip>
          </div>
          <div style={{ paddingRight: "7px" }}>
            <Button
              type="primary"
              onClick={downloadCSV}
            >
              Dowload Calendar
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomToolBar;
